import { Typography } from "@/components/ui/typography";
import formatPerisanDate from "@/utils/formatPerisanDate";
import { HugeiconsIcon } from "@hugeicons/react";
import { WeatherDay } from "./WeatherCarousel";

const WeatherSlide = ({ day }: { day: WeatherDay }) => {
  return (
    <div className="flex flex-col items-center gap-1.5 w-11 shrink-0">
      <Typography
        className="text-[10px]"
        variant="captionBold"
        color="secondary"
      >
        {formatPerisanDate(new Date(day?.date), "M/d")}
      </Typography>
      <HugeiconsIcon size={18} icon={day?.icon} className={day?.className} />
      <Typography className="text-[10px]" variant="captionMedium">
        {Math.round(day?.tempMin)}°/ {Math.round(day?.tempMax)}°
      </Typography>
    </div>
  );
};

export default WeatherSlide;
